/**
 * Cross-component signal for "a customer's credit position changed" — a stop,
 * a lifted stop, new terms, or a decision on held orders.
 *
 * The customer header's credit chip and Settings › Credit both read the same
 * composed credit view but load it on their own, and there is no shared query
 * cache in this app (see ticketEvents.ts). The section that saves a change
 * notifies; the chip refetches, so the header never contradicts the section
 * beside it.
 */
import { useEffect } from "react";

type Listener = () => void;

const listeners = new Set<Listener>();

export function notifyCreditChanged(): void {
  listeners.forEach((listener) => listener());
}

/** Runs `onChange` whenever a credit change is reported. */
export function useCreditChangedListener(onChange: () => void): void {
  useEffect(() => {
    listeners.add(onChange);
    return () => {
      listeners.delete(onChange);
    };
  }, [onChange]);
}
